<template>
  <article id="servicios">
    <img src="/img/servicios.jpg" style=" height: auto;width: 100%;"> 
    <div class="container">
      <h1>SERVICIOS</h1>
        <h2> TECNICO REPARACIÓN:</h2>
        <ul>
          <li>Basculas para camiones y trenes de todas las marcas.</li>
          <li>Basculas de piso, colgantes, de mesa, para ganado, navieras y de uso indistrial en general.</li>
          <li>Mantenimientos Preventivos.</li>
          <li>Contratos de servicios de mantenimientos mensuales y/o anuales.</li>
          <li>Reparamos balanzas mecánicas fuera de uso, transformandolas a electrónicas.</li>
          <li>Traslados y montajes de balanzas nuevas o usadas.</li>
        </ul>
        <h2>CERTIFICACION Y CALIBRACIÓN</h2>
        <ul>
         <li>Asesoramos y gestionamos sus sistemas de pesaje, asegurandonos de que cumpla con la normativa vigente acompañandolo en todo el proceso.</li>
         <li>Gestionamos y contratamos la visita del ente certificador acreditado.</li>
         <li>Calibramos su báscula, asegurándonos que la lectura de su equipo cumple 100% con las Normas legales vigentes.</li>
        </ul>
      </div>
  </article>
</template>

<script>
export default {
  
  
}
</script>


<style>
  #servicios{
    color: #007FC0;
  }
</style>